var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndustryValueChain4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.289,
    height: 37.098,
    viewBox: "0 0 36.289 37.098",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2718.139 -1356.483)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2718.139 1356.483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.553,15.207H10.609V-2.569H-16.224V15.207H-20.95V-7.605l.293-.232L-3.3-21.5l.493-.386.49.386L15.043-7.837l.3.232V15.207Zm-2.371-1.535h1.584V-6.875L-2.805-19.922-19.377-6.875V13.671h1.583V-4.106H12.182V13.671Z",
    transform: "translate(20.95 21.891)",
    fill: "#edaa30"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2611.419 1235.715)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.288-38.78H78.564v3.64h3.725ZM78.4-40.317h4.055a1.414,1.414,0,0,1,.993.405h0a1.352,1.352,0,0,1,.413.969v3.964a1.361,1.361,0,0,1-.413.969l0,0a1.42,1.42,0,0,1-.993.405H78.4a1.408,1.408,0,0,1-.993-.405h0a1.36,1.36,0,0,1-.415-.971v-3.964a1.345,1.345,0,0,1,.413-.969,1.408,1.408,0,0,1,.993-.405",
    transform: "translate(53.482 190.702)",
    fill: "#edaa30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.04-38.78H74.315v3.64H78.04Zm-3.889-1.537h4.055a1.407,1.407,0,0,1,.991.405h0a1.345,1.345,0,0,1,.413.969v3.964a1.354,1.354,0,0,1-.413.969l0,0a1.413,1.413,0,0,1-.991.405H74.151a1.405,1.405,0,0,1-.993-.405h0a1.36,1.36,0,0,1-.415-.971v-3.964a1.345,1.345,0,0,1,.413-.969,1.405,1.405,0,0,1,.993-.405",
    transform: "translate(50.532 190.702)",
    fill: "#edaa30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.288-42.98H78.564v3.64h3.725ZM78.4-44.517h4.055a1.414,1.414,0,0,1,.993.405h0a1.352,1.352,0,0,1,.413.969v3.964a1.353,1.353,0,0,1-.413.971h0a1.422,1.422,0,0,1-.993.405H78.4a1.408,1.408,0,0,1-.993-.405,1.346,1.346,0,0,1-.413-.971v-3.964a1.345,1.345,0,0,1,.413-.969,1.408,1.408,0,0,1,.993-.405",
    transform: "translate(53.482 187.784)",
    fill: "#edaa30"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustryValueChain4);
export default __webpack_public_path__ + "static/media/industry-value-chain-4.56162da51160a6694c0bdc72eda3982e.svg";
export { ForwardRef as ReactComponent };